
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'notificationIconContainer': {'display': `flex`,},'notificationBadge': {'color': `secondary`,},'notificationIcon': {'color': `#ffffff`,'paddingRight': `8px`,'paddingBottom': `5px`,},'redirectLink': {'textDecoration': `none`,'padding': `0`,},
        
      };
    };
  